export default __webpack_public_path__ + "static/media/47SA63.230dd1aa.png";